<ng-container>
    <div *ngIf="routeStation">
        <div class="d-flex flex-column m-2">
            <span class="text-bg-danger ps-2">Name: {{ routeStation.routeStation.name}} </span>
            <span class="text-center "> SAM ID: {{ routeStation.routeStation.samId}} </span>
        </div>

        <div *ngFor="let kanal of routeStation.routeStation.dataEndChannels">
            <div *ngIf="kanal.dataEndChannelType === DeType.BLINKER && kanal.de < 190"
                (click)="onOpenComponentClicked(kanal)">
                <!-- Blinker -->
                <div class="d-flex justify-content-between  bg-light m-2 border border-2 border-secondary"
                    style="cursor: pointer;">
                    <ng-container>
                        <div class="p-2">
                            <span>Blinker</span>
                        </div>
                    </ng-container>

                    <avs-manual-control-result class="w-100" [scenarioManual]="getProperScenarioManual(kanal.id)"
                        [users]="users"></avs-manual-control-result>
                </div>
            </div>

            <!-- Sensor (Smart Micro / VDE / ASIM / ADEC): Typ via Radar-Verknüpfung, Fahrspur aus DE -->
            <div *ngIf="kanal.dataEndChannelType === DeType.RADAR && kanal.de < 190"
                (click)="onOpenComponentClicked(kanal)">
                <div class="d-flex justify-content-between bg-light m-2 border border-2 border-secondary"
                    style="cursor: pointer;">
                    <div class="d-flex flex-column p-1" style="max-width: 130px; overflow-wrap: anywhere;">
                        <span>{{ radarName(kanal) }}</span>
                        <span>{{ lane(kanal) }}</span>
                    </div>

                    <avs-manual-control-result [scenarioManual]="getProperScenarioManual(kanal.id)"
                        [users]="users"></avs-manual-control-result>
                </div>
            </div>

            <div *ngIf="kanal.dataEndChannelType === DeType.LED && kanal.de < 190"
                (click)="onOpenComponentClicked(kanal)">
                <div class="d-flex  bg-light m-2 border border-2 border-secondary" style="cursor: pointer;">
                    <div class="p-2  position-relative">
                        Anzeige
                    </div>
                    <avs-manual-control-result [scenarioManual]="getProperScenarioManual(kanal.id)" [users]="users"
                        [images]="images"></avs-manual-control-result>
                </div>
            </div>

            <div *ngIf="kanal.dataEndChannelType === DeType.PW && kanal.de < 190"
                (click)="onOpenComponentClicked(kanal)" style="cursor: pointer;">
                <div class="d-flex justify-content-between  bg-light m-2 border border-2 border-secondary"
                    style="cursor: pointer;">
                    <div class="p-2">
                        Prismenwender
                    </div>
                    <avs-manual-control-result style="margin-right: 13px;"
                        [scenarioManual]="getProperScenarioManual(kanal.id)" [users]="users"
                        [images]="images"></avs-manual-control-result>
                </div>
            </div>

            <div *ngIf="kanal.dataEndChannelType === DeType.DIGITALOUTPUT && kanal.de < 190"
                (click)="onOpenComponentClicked(kanal)" style="cursor: pointer;">
                <div class="d-flex justify-content-between  bg-light m-2 border border-2 border-secondary"
                    style="cursor: pointer;">
                    <div class="p-2">
                        Ausgang {{ kanal.de }}
                    </div>
                    <avs-manual-control-result [scenarioManual]="getProperScenarioManual(kanal.id)" [users]="users"
                        [images]="images"></avs-manual-control-result>
                </div>
            </div>

            <div *ngIf="kanal.dataEndChannelType === DeType.DIGITALINPUT && kanal.de < 190" (click)="onOpenComponentClicked(kanal)"
                style="cursor: pointer;">
                <div class="d-flex justify-content-between bg-light m-2 border border-2 border-secondary"
                    style="cursor: pointer;">
                    <div class="p-2">
                        Eingang {{ kanal.de }}
                    </div>
                    <avs-manual-control-result [scenarioManual]="getProperScenarioManual(kanal.id)" [users]="users"
                        [images]="images"></avs-manual-control-result>
                </div>
            </div>

            <div *ngIf="isBarrierChannel(kanal)" (click)="onOpenComponentClicked(kanal)" style="cursor: pointer;">
                <div class="d-flex justify-content-between bg-light m-2 border border-2 border-secondary"
                    style="cursor: pointer;">
                    <div class="p-2">
                        {{ getBarrierChannelName(kanal) }}
                    </div>
                    <avs-manual-control-result [scenarioManual]="getProperScenarioManual(kanal.id)" [users]="users">
                    </avs-manual-control-result>
                </div>
            </div>

        </div>
    </div>
</ng-container>
